module.exports = __webpack_public_path__ + "img/Klaus_Schöffmann@2x.84c7c93b.png";